import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Nav, NavItem } from '@feathr/components';
import { useGoogleAdsPermissions, useLicense } from '@feathr/extender/hooks';
import { useAccount, useLocalUrl } from '@feathr/extender/state';

function HomeMarketingNav(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();

  const { isPlatformLite } = useAccount();
  const { googleAdsSmart, hasMonetization } = useLicense();
  // Google Ads is still flagged, so we need to check if the user has access to it.
  const showGoogleAds = useGoogleAdsPermissions();

  return (
    <Nav indented={true} label={t('Marketing navigation')} type={'vertical'}>
      <NavItem isForwardedFrom={localUrl(`/marketing`)} to={localUrl('/marketing/all')}>
        {t('All')}
      </NavItem>
      <NavItem to={localUrl('/marketing/ads')}>{t('Ads')}</NavItem>
      <NavItem to={localUrl('/marketing/email')}>{t('Email')}</NavItem>
      {googleAdsSmart && showGoogleAds && (
        <NavItem to={localUrl('/marketing/google-ads')}>{t('Google Ads')}</NavItem>
      )}
      {hasMonetization && (
        <NavItem to={localUrl('/marketing/monetization')}>{t('Monetization')}</NavItem>
      )}
      {!isPlatformLite && <NavItem to={localUrl('/marketing/other')}>{t('Other')}</NavItem>}
    </Nav>
  );
}

export default HomeMarketingNav;
